module.exports = __webpack_public_path__ + "static/img/back.a08bf60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.svg
// module id = UAVG
// module chunks = 1